import type { RxJsonSchema } from 'rxdb';
import type { PurchaseOrderDocType } from '../types/purchaseOrder';

export const purchaseOrderSchema: RxJsonSchema<PurchaseOrderDocType> = {
  version: 0,
  primaryKey: 'id',
  type: 'object',
  properties: {
    id: { type: 'string', maxLength: 36 },
    orderNumber: { type: 'string', maxLength: 30 },
    supplierId: { type: 'string', maxLength: 36 },
    status: { 
      type: 'string', 
      enum: ['draft', 'pending', 'confirmed', 'received', 'cancelled'] 
    },
    expectedDate: { type: 'string' },
    receivedDate: { type: 'string' },
    items: { type: 'array', items: { type: 'object' } },
    totalItems: { type: 'number', default: 0 },
    totalQuantity: { type: 'number', default: 0 },
    totalAmount: { type: 'number', default: 0 },
    notes: { type: 'string' },
    createdBy: { type: 'string', maxLength: 36 },
    createdAt: { type: 'string' },
    updatedAt: { type: 'string' },
    _deleted: { type: 'boolean', default: false },
  },
  required: ['id', 'orderNumber', 'supplierId', 'status', 'createdAt', 'updatedAt'],
};
